(function ($) {
  var namespace = 'scrollchecker'
  var methods = {
    init: function (options) {
      options = $.extend({
        fixedPosition: 120, // 止めるtopの位置
        fixedClass: 'fixed',
        fixedAfterClass: 'fixed-after',
        afterInterval: 10
      }, options)
      return this.each(function () {
        var $this = $(this)
        var data = $this.data(namespace)
        if (!data) {
          options = $.extend({}, options)
          $this.data(namespace, {
            options: options
          })

          // var offset = $this.offset()
          if ($this.length > 0) {
            $(window).scroll(function () {
              if ($(window).scrollTop() > options.fixedPosition) {
                $this.addClass(options.fixedClass)
                setTimeout(function () {
                  $this.addClass(options.fixedAfterClass)
                }, options.afterInterval)
              } else {
                $this
                  .removeClass(options.fixedClass)
                  .removeClass(options.fixedAfterClass)
              }
            })
          }
        }
      }) // end each
    }
  }
  $.fn.scrollchecker = function (method) {
    if (methods[method]) {
      return methods[method].apply(this, Array.prototype.slice.call(arguments, 1))
    } else if (typeof method === 'object' || !method) {
      return methods.init.apply(this, arguments)
    } else {
      $.error('Method ' + method + ' does not exist on jQuery.' + namespace)
    }
  }
})($)



// WEBPACK FOOTER //
// ./src/js/lib/scrollchecker.js